export default "__VITE_ASSET__075c53bf__"